import { status } from '../typeStatus'
import {
  LogAccesoState,
  initialState,
  LogAccesoActions,
  GET_LOG_ACCESO,
  GET_LOG_ACCESO_SUCCESS,
  GET_LOG_ACCESO_ERROR,
  GET_LOG_ACCESO_RESET,
} from './types'

const reducers = (state: LogAccesoState = initialState, action: LogAccesoActions): LogAccesoState => {
  switch (action.type) {
    case GET_LOG_ACCESO:
      return {
        ...state,
        status: status.loading,
        pagination: null,
      }
    case GET_LOG_ACCESO_SUCCESS:
      return {
        ...state,
        status: status.success,
        content: [...state.content, ...action.payload.content],
        pagination: action.payload.pagination,
      }
    case GET_LOG_ACCESO_ERROR:
      return {
        ...state,
        status: status.error,
        content: [],
        pagination: null,
      }
    case GET_LOG_ACCESO_RESET:
      return {
        ...state,
        status: status.initial,
        content: [],
        pagination: null,
      }
    default:
      return state
  }
}
export default reducers
